import { useRoom } from "../room/useRoom";
import { usePeers } from "../room/usePeers";
import { PeerRow } from "./PeerRow";

export function PeerList() {
  const { roomId } = useRoom();
  const peers = usePeers();

  if (!roomId) {
    return (
      <main className="flex flex-1 flex-col items-center justify-center gap-2 px-4 text-center">
        <p className="text-[var(--muted)]">Create or join a room to connect your devices.</p>
      </main>
    );
  }

  if (peers.length === 0) {
    return (
      <main className="flex flex-1 flex-col items-center justify-center gap-2 px-4 text-center">
        <p className="text-[var(--muted)]">Waiting for other devices…</p>
        <p className="text-xs text-[var(--muted)]">Open this room on another device to pair.</p>
      </main>
    );
  }

  return (
    <main className="flex flex-1 flex-col gap-2 px-4 py-4">
      <ul className="mx-auto flex w-full max-w-md flex-col gap-2">
        {peers.map((p) => <PeerRow key={p.peerId} peer={p} />)}
      </ul>
      <p className="mx-auto mt-4 text-center text-xs text-[var(--muted)] max-w-xs leading-relaxed">
        💡 Tap/Click a device to send files.<br />
        Hold/Right-click to send a text message.
      </p>
    </main>
  );
}
